/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-19 14:55:01
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { Banner, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import history from 'src/routes/history';

type Props = {};

type ComposedProps = Props & WithI18nProps;

class InvalidMetafieldsFound extends Component<ComposedProps> {
  render() {
    const { i18n } = this.props;
    return (
      <Banner
        title={i18n.translate('AdminHTML.Dashboard.Notifications.invalidMetafieldsFound_Title')}
        status="warning">
        <p id="title-error-metafield">
          {i18n.translate('AdminHTML.Dashboard.Notifications.invalidMetafieldsFound_Content', {
            t: (
              <Button
                plain
                onClick={() => {
                  history.push('/metafield');
                }}>
                {i18n.translate(
                  'AdminHTML.Dashboard.Notifications.invalidMetafieldsFound_Content_t'
                )}
              </Button>
            )
          })}
        </p>
      </Banner>
    );
  }
}

export default withI18n()(InvalidMetafieldsFound);
